export const defaultValidateMessages = {
    default: "Validation error on field '{name}'",
    required: "'{name}' is required",
    min: "'{name}' must be minimum {min}",
    max: "'{name}' must be maximum {max}",
    minLength: "'{name}' must be at least {minLength} characters",
    maxLength: "'{name}' must be up to {maxLength} characters",
};
export const HOOK_MARK = Symbol('FORM_INTERNAL_HOOKS');
